import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'
import { CORE_LESSON_COMPLETION_FLAG } from './constants'

const TrainingReportFlagRouter = FlagsComponentRouter({
  flagSubscriptions: [CORE_LESSON_COMPLETION_FLAG],
  OnComponent,
  OffComponent,
})

export default TrainingReportFlagRouter
